import React, { useState } from 'react';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import { FormControl, InputLabel, Paper, Divider} from '@mui/material';
import { post } from '../api/api';
import { withRouter } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import { cacheEnums, cacheAssets } from '../utils/cache';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';
import Collapse from "@mui/material/Collapse";
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';



function LoginForm({ history, auth, setAuth }) {
  React.useEffect(() => {
    if (localStorage.jwtToken) history.push('/');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [state, setState] = React.useState({
    baseUrl: '',
    apiClientUsername: '',
    apiClientPassword: '',
    clientUsername: '',
    clientPassword: '',
    showClientPassword: false,
    showPassword: false,
  });

  const handleChange = (e) => {
    setState({ ...state, [e.currentTarget.id]: e.currentTarget.value });
  };

  const handleClickShowClientPassword = () => {
    setState({
      ...state,
      showClientPassword: !state.showClientPassword,
    });
  };

  const handleClickShowPassword = () => {
    setState({
      ...state,
      showPassword: !state.showPassword,
    });
  };

  const handleMouseDownClientPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const Alerta = () => (
      <Box
        sx={{
          marginTop : 1,
        }}
      >
        <Alert
          severity = "error"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
        <AlertTitle>Login Failed</AlertTitle>
          The login failed. Please, check your credentials and try again or contact site administrators.
        </Alert>
      </Box>
  );

  const [open, setOpen] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    localStorage.setItem('baseUrl', state.baseUrl);
    post(
      '/tokens',
      {
        username: state.clientUsername,
        password: state.clientPassword,
        grant_type: 'password',
      },
      {
        auth: {
          username: state.apiClientUsername,
          password: state.apiClientPassword,
        },
      },
    ).then((res) => {
      if (res.data.access_token) {
        localStorage.setItem('jwtToken', res.data.access_token);
        const decoded = jwt_decode(localStorage.jwtToken);
        setAuth({
          ...auth,
          isAuthenticated: true,
          token: localStorage.jwtToken,
          currentUser: decoded,
        });

        // cache data
        Promise.all([cacheAssets(res.data.access_token), cacheEnums(res.data.access_token)]).then((values) => {
          history.push('/');
        })
      }
    }).catch(
      () => setOpen(true)
    );
  };

  return (
    <Paper
      style={{
        margin: '0 auto',
        padding: '20px',
        marginTop: '30px',
        minWidth: '300px',
        maxWidth: '400px',
      }}
    >
      <Paper elevation={0} style={{ backgroundColor: 'transparent' }}>
        <img src='/LogoOnyzeblanco.png' alt='logo' width='150px' />
      </Paper>
      <h1>CaaS Frontoffice</h1>
      <Divider />
      <h3>User access</h3>
      <form
        onSubmit={handleLogin}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <FormControl>
          <InputLabel>Hostname</InputLabel>
          <Input
            id='baseUrl'
            formControlProps={{
              fullWidth: true,
            }}
            onChange={handleChange}
            type='text'
          />
        </FormControl>
        <Divider style={{ marginTop: '1em' }} />
        <FormControl style={{ marginTop: '1rem' }}>
          <InputLabel>API Client Username</InputLabel>
          <Input
            id='apiClientUsername'
            formControlProps={{
              fullWidth: true,
            }}
            onChange={handleChange}
            type='text'
          />
        </FormControl>
        <Divider />
        <FormControl style={{ marginTop: '1rem' }}>
          <InputLabel>API Client Password</InputLabel>
          <Input
            id='apiClientPassword'
            formControlProps={{
              fullWidth: true,
            }}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickShowClientPassword}
                  onMouseDown={handleMouseDownClientPassword}
                  edge='end'
                >
                  {state.showClientPassword ? (
                    <VisibilityOff />
                  ) : (
                    <Visibility />
                  )}
                </IconButton>
              </InputAdornment>
            }
            type={state.showClientPassword ? 'text' : 'password'}
          />
        </FormControl>
        <Divider style={{ marginTop: '1em' }} />
        <FormControl style={{ marginTop: '1rem' }}>
          <InputLabel>Username</InputLabel>
          <Input
            id='clientUsername'
            formControlProps={{
              fullWidth: true,
            }}
            onChange={handleChange}
            type='text'
          />
        </FormControl>
        <FormControl style={{ marginTop: '1rem' }}>
          <InputLabel>Password</InputLabel>
          <Input
            id='clientPassword'
            formControlProps={{
              fullWidth: true,
            }}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'
                >
                  {state.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            type={state.showPassword ? 'text' : 'password'}
          />
        </FormControl>
        <Divider light />
        <Box style={{ alignItems: 'center' }}>
          <Button
            type='submit'
            variant="contained"
            size="large"
            style={{ marginTop: '1em', fontSize: 'larger', color: '#fff', maxWidth: 140, textTransform: 'none' }}
          >
            Log In
          </Button>
          <Collapse in={open}>
            <Alerta></Alerta>
          </Collapse>
        </Box>
      </form>
    </Paper>
  );
}

export default withRouter(LoginForm);
